var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fa897d2210e76ee0cad5558868639f17ea9cb09e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eth-dapp-v2@staderlabs"]={id:"fa897d2210e76ee0cad5558868639f17ea9cb09e"};
      